$(document).on('click', '[data-goal]', function () {
    if (typeof ym === 'function' && window.metrica_id) {
        ym(window.metrica_id, 'reachGoal', $(this).data('goal'));
    }
});
